import { useContext } from 'react'

import { AiChatContext } from '../context/AiChatContext'

export const useAiChatContext = () => {
    return useContext(AiChatContext);
}